module.exports = __webpack_public_path__ + "img/squarespace.965796e0.svg";